import React from "react";

import { createContext } from "react";

const NoteContext = createContext();

export default NoteContext;
